module.exports = __webpack_public_path__ + "img/ICONT_DT.6af9fa35.png";